'use client'

import { useEffect } from 'react'

import { viewItemEvent, viewOwnItemEvent } from '@marketplace-web/item-page/item-page-data'
import { getSearchSessionData } from '@marketplace-web/search/search-feature'
import { useTrackAbTest, useAbTest } from '@marketplace-web/feature-flags/ab-tests-data'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useSession } from '@marketplace-web/shared/session-data'

import { getReferrerPath } from '../utils/url'

type Props = {
  itemId: number
  sellerId: number
  isOnHoliday: boolean
  children: React.ReactNode
}

const ItemPageLayoutWrapper = ({ itemId, sellerId, isOnHoliday, children }: Props) => {
  const { track } = useTracking()

  const currentUserId = useSession().user?.id

  const { searchSessionId, globalCatalogBrowseSessionId } = getSearchSessionData()

  const holidayModeRedirectAbTest = useAbTest('holiday_mode_redirect')

  useTrackAbTest(
    holidayModeRedirectAbTest,
    holidayModeRedirectAbTest?.variant === 'off' && isOnHoliday,
  )
  useTrackAbTest(useAbTest('web_item_page_breadcrumbs_rework'))

  useEffect(() => {
    if (!itemId) return

    const referrerPath = getReferrerPath()

    if (currentUserId === sellerId) {
      track(
        viewOwnItemEvent({
          referrerPath,
          searchSessionId,
          itemId,
          ownerId: sellerId,
        }),
      )

      return
    }

    track(
      viewItemEvent({
        referrerPath,
        searchSessionId,
        globalCatalogBrowseSessionId,
        itemId,
        ownerId: sellerId,
      }),
    )
  }, [track, currentUserId, searchSessionId, globalCatalogBrowseSessionId, itemId, sellerId])

  return children
}

export default ItemPageLayoutWrapper
